module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/confirm_de-dd052d5071f09fd5606973e6fa46e41e.gif";